import React, {useEffect, useState, useRef} from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCoverflow, Pagination, Navigation, Grid, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/grid'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import TestimonialsSwiperCard from './testimonials.swiper.card'

const TestimonialsSwiperCarousel = ({ data, effect, rows, slidesPerView, initialSlide, autoplay=false, customClassName }) => {
    const modules = effect === 'coverflow' ? [EffectCoverflow, Navigation, Pagination, Autoplay] : effect === 'grid' ? [Grid, Navigation, Pagination]: [Navigation, Pagination, Autoplay]

    // refs para audios/videos/YouTube
    const playersRef = useRef([])

    const handlePlay = (index) => {
        playersRef.current.forEach((player, i) => {
            if (!player) return
            if (i !== index) {
                // HTML5 audio/video
                if (player.pause) {
                    player.pause()
                }
                // YouTube API
                if (player.stopVideo) {
                    player.stopVideo()
                }
            }
        })
    }

    return (
        <Swiper
            effect={effect ?? ''}
            grid={{
                rows: effect === 'grid' ? rows : 1,
                fill: 'row'
            }}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={slidesPerView}
            initialSlide={initialSlide ?? 1} // arranca en el del medio
            spaceBetween={40}
            coverflowEffect={effect === 'coverflow' ? {
                rotate: 10,
                stretch: 0,
                depth: 100,
                modifier: 2,
                slideShadows: false,
            } : ''}
            pagination={{ clickable: true }}
            navigation={true}
            modules={modules}
            autoplay={autoplay ? {
                delay: 9000,
                disableOnInteraction: true,
            } : false}
            className={customClassName ? customClassName : "swiper-carrusel-custom"}
        >
            {data?.map((item, index) => (
                <SwiperSlide
                    key={index}
                    style={{ width: '340px', height: 'auto' }}
                >
                    <TestimonialsSwiperCard item={item} index={index} playersRef={playersRef} onPlay={handlePlay} />
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default TestimonialsSwiperCarousel
